<template>
  <div>
    <b-alert show>
      Make certain you are updating the proper account
    </b-alert>
    <b-form v-if="false" class="form profile-name">
      <b-row>
        <b-col>
          <span
            v-if="settingsGen._isLockedResource"
            class="order-icon"
            @click="toggleResourcesSetting"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.91667 6.99967C2.5945 6.99967 2.33333 7.26084 2.33333 7.58301V11.6663C2.33333 11.9885 2.5945 12.2497 2.91667 12.2497H11.0833C11.4055 12.2497 11.6667 11.9885 11.6667 11.6663V7.58301C11.6667 7.26084 11.4055 6.99967 11.0833 6.99967H2.91667ZM1.16667 7.58301C1.16667 6.61651 1.95017 5.83301 2.91667 5.83301H11.0833C12.0498 5.83301 12.8333 6.61651 12.8333 7.58301V11.6663C12.8333 12.6328 12.0498 13.4163 11.0833 13.4163H2.91667C1.95017 13.4163 1.16667 12.6328 1.16667 11.6663V7.58301Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 1.74967C6.38116 1.74967 5.78767 1.99551 5.35008 2.43309C4.9125 2.87068 4.66667 3.46417 4.66667 4.08301V6.41634C4.66667 6.73851 4.4055 6.99967 4.08333 6.99967C3.76117 6.99967 3.5 6.73851 3.5 6.41634V4.08301C3.5 3.15475 3.86875 2.26451 4.52513 1.60813C5.1815 0.951757 6.07174 0.583008 7 0.583008C7.92826 0.583008 8.8185 0.951757 9.47487 1.60813C10.1313 2.26451 10.5 3.15475 10.5 4.08301V6.41634C10.5 6.73851 10.2388 6.99967 9.91667 6.99967C9.5945 6.99967 9.33333 6.73851 9.33333 6.41634V4.08301C9.33333 3.46417 9.0875 2.87068 8.64992 2.43309C8.21233 1.99551 7.61884 1.74967 7 1.74967Z"
                fill="#B3C2CB"
              />
            </svg>
          </span>
          <span v-else class="order-icon" @click="toggleResourcesSetting">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0832 13.4163H2.9165C1.92484 13.4163 1.1665 12.658 1.1665 11.6663V7.58301C1.1665 6.59134 1.92484 5.83301 2.9165 5.83301H11.0832C12.0748 5.83301 12.8332 6.59134 12.8332 7.58301V11.6663C12.8332 12.658 12.0748 13.4163 11.0832 13.4163ZM2.9165 6.99967C2.5665 6.99967 2.33317 7.23301 2.33317 7.58301V11.6663C2.33317 12.0163 2.5665 12.2497 2.9165 12.2497H11.0832C11.4332 12.2497 11.6665 12.0163 11.6665 11.6663V7.58301C11.6665 7.23301 11.4332 6.99967 11.0832 6.99967H2.9165Z"
                fill="var(--theme-color)"
              />
              <path
                d="M4.08317 6.99967C3.73317 6.99967 3.49984 6.76634 3.49984 6.41634V4.08301C3.49984 3.14967 3.84984 2.27467 4.54984 1.63301C5.1915 0.933008 6.0665 0.583008 6.99984 0.583008C8.63317 0.583008 10.0915 1.74967 10.4415 3.38301C10.4998 3.67467 10.2665 4.02467 9.97484 4.08301C9.68317 4.14134 9.33317 3.96634 9.27484 3.61634C9.0415 2.50801 8.10817 1.74967 6.99984 1.74967C6.35817 1.74967 5.77484 1.98301 5.3665 2.44967C4.89984 2.85801 4.6665 3.44134 4.6665 4.08301V6.41634C4.6665 6.76634 4.43317 6.99967 4.08317 6.99967Z"
                fill="var(--theme-color)"
              />
            </svg>
          </span>
          <p>
            {{ settingsGen._isLockedResource ? "Unlock" : "Lock" }} Resource
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5">
          <b-form-group
            label="Resource Name"
            label-for="input-3"
            class="custom-label"
          >
            <b-form-input
              id="input-3"
              v-model.trim="settingsGen.resourceName"
              class="custom-input"
              placeholder="Resource Name"
              type="text"
              @change="handleSettingsGenChange"
              :disabled="!hasPermission"
            />
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";
export default {
  name: "BaseSettings",
  components: {
    TogglesForm
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  beforeMount() {
    //this.settingsGen = this.settings && this.settings.gen ? this.settings.gen : {};
    this.setUpToggles();
  },
  created() {
    this.handleSettingsGenChange();
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    hasPermission() {
      return true;
    }
  },
  methods: {
    setUpToggles() {
      this.toggles.forEach(aToggle => {
        if (this.settingsGen.hasOwnProperty(aToggle.property)) {
          aToggle.value = this.settingsGen[aToggle.property];
        }
      });
    },
    handleToggleChange(event) {
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsGen[checkedId] = event.target.checked
          ? event.target.checked
          : false;
      }
      this.handleSettingsGenChange();
    },
    toggleResourcesSetting() {
      this.settingsGen._isLockedResource = !this._isLockedResource;
      this.handleSettingsGenChange();
    },
    handleSettingsGenChange() {
      const payload = {
        settingsGen: this.settingsGen,
        toolId: this.resource.toolId
      };
      this.$store.dispatch("tools/setSettingsGenForTool", payload);
    }
  },
  data() {
    return {
      settingsGen: {
        _isLockedResource:
          this.settings &&
          this.settings.gen &&
          this.settings.gen._isLockedResource !== undefined
            ? this.settings.gen._isLockedResource
            : true,
        _isActive:
          this.settings &&
          this.settings.gen &&
          this.settings.gen._isActive !== undefined
            ? this.settings.gen._isActive
            : true,
        _isHidden:
          this.settings &&
          this.settings.gen &&
          this.settings.gen._isHidden !== undefined
            ? this.settings.gen._isHidden
            : true,
        resourceName:
          this.settings && this.settings.gen && this.settings.gen.resourceName
            ? this.settings.gen.resourceName
            : ""
      },
      toggles: [
        {
          name: "Active",
          property: "_isActive",
          type: "btns",
          text: "Enable if you want the resource to be active in your corner",
          value: true
        },
        {
          name: "Hidden",
          property: "_isHidden",
          type: "btns",
          text: "Choose whether or not to hide it from the display",
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
